<template>
    <div class="digital-agency-grid">
        <span class="digital-agency-assistance__warap wow move-up" v-for="(item, index) in services" :key="index">
            <div class="digital-agency-assistance__box">
                <div class="digital-agency-assistance__images">
                    <div class="images-midea">
                        <img :src="item.img" class="img-fluid" alt="service thumb">
                        <h5 class="heading">{{ item.heading }}</h5>
                    </div>
                </div>
                <div class="digital-agency-assistance__content mt-30 text-center">
                    <p>{{ item.desc }}</p>
                </div>
            </div>
        </span>
    </div>
</template>

<script>
    export default{
        name: 'WhaleioCapabilities',
        data(){
            return {
                services: [
                    {
                        img: require('../assets/img/agency/agency-service-01.jpg'),
                        heading: 'Website & App Designing',
                        desc: 'Our technical experts have a flair for developing clean-coded websites based on customers’ needs, global guidelines and trends.'
                    },
                    {
                        img: require('../assets/img/agency/embedded.png'),
                        heading: 'Embedded Design & Development',
                        desc: 'Our workforce is experienced in embedded design targeting VHDL, Verilog or mixed platforms and we provide certified expertise in developing SoC and edge computing devices against industry leading hardware, including platform acceleration using Xilinx devices.'
                    },
                    {
                        img: require('../assets/img/agency/drone.png'),
                        heading: 'Data Science',
                        desc: 'Our team stands up modern data solutions with computer vision, artificial intelligence, and other rising technologies to deliver data-driven solutions.'
                    },
                    {
                        img: require('../assets/img/agency/programmer-whiteboard.png'),
                        heading: 'Software & Systems Engineering',
                        desc: 'Our team integrates and delivers hardware and software systems, along with project management to ensure mission success.'
                    },
                    {
                        img: require('../assets/img/agency/server-room.png'),
                        heading: 'Cloud Infrastructure',
                        desc: 'Experience in deploying Software-as-a-Servive and Platforms-as-a-Service environments fully equipped with storage, databases, server/serverless architectures, and custom software.'
                    }
                ]
            }
        }
    };
</script>

<style lang="scss">

</style>